import { render } from "./Visa.vue?vue&type=template&id=38bf6bfa"
import script from "./Visa.vue?vue&type=script&lang=js"
export * from "./Visa.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "38bf6bfa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('38bf6bfa', script)) {
    api.reload('38bf6bfa', script)
  }
  
  module.hot.accept("./Visa.vue?vue&type=template&id=38bf6bfa", () => {
    api.rerender('38bf6bfa', render)
  })

}

script.__file = "src/icons/components/logos/Visa.vue"

export default script